import React, { useRef, useState, useMemo, useEffect } from "react";
import {
  ButtonCancel,
  ButtonCreate,
  ContentCreate,
  ContentFields,
  ContentField,
  ContentButtons,
  ContentFile,
  AccordeonLine,
  FieldFile,
  ContentSetHours,
  ContentResume,
  InfoHours,
  ButtonAddHours,
  CopyHours,
  CardHours,
  ContentCopy,
  ButtonsCopy,
  ContainFormCheck,
  FormLabelCheck,
  FormForCheck,
} from "./CreateCoachComponent.styled";
import { useHistory, useLocation } from "react-router-dom";
import CloseIcon from "@material-ui/icons/Close";
import { Form } from "react-bootstrap";
import Select from "react-select";
import PersonIcon from "@material-ui/icons/Person";
import FileUpload from "../FileUpload";
import { NotificationManager } from "react-notifications";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { withStyles } from "@material-ui/core/styles";
import RenderInputsComponent from "../RenderInputsComponent/RenderInputsComponent";
import DateFnsUtils from "@date-io/date-fns";
import PortalModal from "../../Portals";
import moment from "moment";
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
} from "@material-ui/pickers";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import { UPDATE_WORKING_HOURS_COACH } from "../../GraphQL/Mutations";
import { useMutation } from "@apollo/client";
import { clientWellness } from "../../App";
import PropTypes from "prop-types";
import { theme as themeConfig } from "../../themes/themes";

const customStyles = {
  control: (base, state) => ({
    ...base,
    boxShadow: "none",
    borderColor: themeConfig.primary.icon,
    "&:hover": {
      borderColor: themeConfig.primary.blue,
      boxShadow: `0 0 0 0.2rem ${themeConfig.primary.blue}40`,
    },
  }),
};
const StyledAccordion = withStyles({
  root: {
    background: themeConfig.background.light,
    padding: "0 !important",
    boxShadow: "none",
    "&::before": {
      backgroundColor: themeConfig.background.light,
    },
  },
  expanded: {
    margin: "0px !important",
  },
})(Accordion);

const StyledAccordionDetails = withStyles({
  root: {
    // background: '#fafafa',
    // borderRadius: 3,
    // border: 0,
    // color: 'white',
    // height: 48,
    padding: "0 !important",
    // boxShadow: 'none',
    // '&::before': {
    //   backgroundColor: '#fafafa'
  },
  // },
  // expanded: {
  //   margin: '0px !important'
  // }
})(AccordionDetails);

const CreateCoachComponent = ({
  languages,
  usersForCoach,
  workingHours,
  userSelected,
  coachEdit,
  files,
  setFiles,
  setWhsModified,
  setWorkingHours,
  createNew,
  updateOld,
  action,
  handleCallSpecificUser,
  loadingCoverImage,
}) => {
  const [, setDataBulkUpload] = useState([]);
  const history = useHistory();
  const [showHoursCopy, setShowHoursCopy] = useState(false);
  let [hoursCopied, setHoursCopied] = useState([]);
  const [renderAgain, setRenderAgain] = useState(false);
  const [startHour, setStartHour] = useState(new Date());
  const [endHour, setEndHour] = useState(new Date());
  const [, setShowLoader] = useState(false);
  const [, setOpenModal] = useState(false);
  const rExperience = useRef();
  const rYearsTP = useRef();
  const rPosition = useRef();
  const location = useLocation();
  const rEmail = useRef();
  const rCountry = useRef();
  const rCity = useRef();
  const rLanguages = useRef();
  const rUserCoach = useRef();
  const rDescription = useRef();
  const rDaysOfWeek = useRef();
  const rEndTime = useRef();
  const [optionsEndTime, setOptionsEndTime] = useState([]);
  const folderName = useMemo(() => "Coaches", []);
  const [usersCoach, setUsersCoach] = useState([]);
  const [runUpdateWorkingHoursCoach] = useMutation(UPDATE_WORKING_HOURS_COACH, {
    client: clientWellness,
  });
  const removeSpace = (obj) => {
    obj.ref.current.value = obj.ref.current.value.replace(/ /g, "");
    setRenderAgain(!renderAgain);
  };

  const executefn = () => {
    setTimeout(() => {
      setRenderAgain(!renderAgain);
    }, 100);
  };

  let fields = [
    {
      type: "select",
      label: "User",
      field: "User",
      ref: rUserCoach,
      fn: () => {
        setTimeout(() => {
          handleCallSpecificUser(rUserCoach);
        }, 100);
      },
      placeholder: "Please select a user",
      data: usersCoach,
      mandatory: true,
      isMulti: false,
      isDisabled: Object.keys(coachEdit).length > 0 ? true : false,
    },
    {
      type: "text",
      label: "Email",
      field: "Email",
      ref: rEmail,
      fn: removeSpace,
      placeholder: "Please enter your email",
      regexp: /^[^@]+@[^@]+\.[A-Z]+$/i,
      mandatory: false,
      isDisabled: true,
    },
    {
      type: "text",
      label: "Country",
      field: "Country",
      ref: rCountry,
      fn: executefn,
      placeholder: "",
      data: [],
      mandatory: false,
      isMulti: false,
      isDisabled: true,
    },
    {
      type: "text",
      label: "City",
      field: "City",
      ref: rCity,
      fn: executefn,
      placeholder: "",
      data: [],
      mandatory: false,
      isMulti: false,
      isDisabled: true,
    },
    {
      type: "select",
      label: "Languages",
      field: "Languages",
      ref: rLanguages,
      fn: executefn,
      placeholder: "",
      data: languages,
      mandatory: true,
      isMulti: true,
    },
    {
      type: "number",
      label: "Exp. years",
      field: "Experience",
      ref: rExperience,
      fn: () => {
        rExperience.current.value = rExperience.current.value.substring(0, 2);
        executefn();
      },
      placeholder: "Type here",
      mandatory: true,
    },
    {
      type: "number",
      label: "Years in TP",
      field: "Years",
      ref: rYearsTP,
      fn: () => {
        rYearsTP.current.value = rYearsTP.current.value.substring(0, 2);
        executefn();
      },
      placeholder: "Type here",
      mandatory: true,
    },
    {
      type: "text",
      label: "Position",
      field: "Position",
      ref: rPosition,
      fn: executefn,
      placeholder: "Please enter your position",
      regexp: /[¡!¿?=\-+*()/[\]&%|$#."_@]/i,
      mandatory: true,
    },
    {
      type: "textarea",
      label: "Description",
      field: "Description",
      ref: rDescription,
      fn: executefn,
      placeholder: "Please enter a description",
      mandatory: true,
    },
  ];

  const validateData = () => {
    let data = {};
    let missingData = false;
    let errorData = false;
    for (let index = 0; index < fields.length; index++) {
      if (!fields[index].mandatory) {
        data[fields[index].field] = fields[index].ref.current.value;
      } else if (
        fields[index].mandatory &&
        ((fields[index].type === "select" &&
          !fields[index].ref.current.state.ariaSelection) ||
          (fields[index].type === "select" &&
            fields[index].isMulti &&
            !fields[index].ref.current.state.selectValue.length) ||
          (fields[index].type === "text" &&
            fields[index].ref.current.value === "") ||
          (fields[index].type === "number" &&
            fields[index].ref.current.value === "") ||
          (fields[index].type === "textarea" &&
            fields[index].ref.current.value === ""))
      ) {
        missingData = true;
        break;
      } else if (
        (fields[index].field === "Email" &&
          fields[index].regexp &&
          !fields[index].regexp.test(fields[index].ref.current.value)) ||
        (fields[index].field !== "Email" &&
          fields[index].regexp &&
          fields[index].regexp.test(fields[index].ref.current.value))
      ) {
        errorData = true;
        break;
      } else {
        data[fields[index].field] =
          fields[index].type === "select"
            ? fields[index].ref.current.state.ariaSelection
            : fields[index].ref.current.value;
      }
      if (index === fields.length - 1) {
        data["file"] = files.file;
      }
    }
    if (!missingData && !errorData) {
      if (action === "add") createNew(data, folderName);
      else if (action === "edit") updateOld(data, folderName);
      return;
    }
    if (errorData)
      NotificationManager.warning("there are errors in the fields", "", 5000);
    else if (missingData)
      NotificationManager.warning("Missing fields", "", 5000);
  };

  const validateWorkingHours = () => {
    if (rDaysOfWeek.current.state.ariaSelection?.value && startHour < endHour) {
      if (action === "add") {
        let whs = Object.assign({}, workingHours);
        let correctRange = true;
        whs[rDaysOfWeek.current.state.ariaSelection.value?.value]
          .sort((a, b) => a.start - b.start)
          .forEach((m) => {
            if (
              (m.start < startHour && startHour < m.end) ||
              (m.start < endHour && endHour < m.end) ||
              (startHour <= m.start && m.end <= endHour)
            ) {
              correctRange = false;
            }
          });
        if (correctRange) {
          whs[rDaysOfWeek.current.state.ariaSelection.value?.value].push({
            start: startHour,
            end: endHour,
          });
          setWorkingHours(whs);
          setWhsModified(true);
        } else {
          NotificationManager.warning(
            "the date range is not correct",
            "",
            5000
          );
        }
      }
      if (action === "edit") {
        let whs = Object.assign({}, workingHours);
        let workingHoursSave = [];
        whs[rDaysOfWeek.current.state.ariaSelection.value?.value].sort(
          (a, b) => a.start - b.start
        );
        whs[rDaysOfWeek.current.state.ariaSelection.value?.value].push({
          start: startHour,
          end: endHour,
        });
        Object.getOwnPropertyNames(whs).forEach((m) => {
          whs[m].forEach((h) => {
            let startTime = `PT${moment(h.start).format("HH")}H${moment(
              h.start
            ).format("mm")}M`;
            let finishTime = `PT${moment(h.end).format("HH")}H${moment(
              h.end
            ).format("mm")}M`;
            workingHoursSave.push({
              weekday: m.toUpperCase(),
              startTime: startTime,
              finishTime: finishTime,
            });
          });
        });
        if (workingHoursSave.length > 0) {
          runUpdateWorkingHoursCoach({
            variables: {
              input: {
                coachId: location.state.coachId,
                workingHours: workingHoursSave,
              },
            },
          })
            .then((response) => {
              setWhsModified(true);
              setShowLoader(false);
              setOpenModal(true);
            })
            .catch((error) => {
              const errorMessage = error.message.split("\n")[0];
              NotificationManager.error(errorMessage, "", 5000);
              setShowLoader(false);
              setOpenModal(false);
              whs[rDaysOfWeek.current.state.ariaSelection.value?.value].pop();
              setWorkingHours(whs);
              setWhsModified(true);
            });
        } else {
          NotificationManager.warning(
            "The working hours are mandatory",
            "",
            5000
          );
          setShowLoader(false);
        }
      }
    } else {
      if (!rDaysOfWeek.current.state.ariaSelection?.value) {
        NotificationManager.warning("Select day of week", "", 5000);
      }
    }
  };

  const removeHours = (day, index) => {
    let whs = Object.assign({}, workingHours);
    whs[day].splice(index, 1);
    let workingHoursSave = [];
    Object.getOwnPropertyNames(whs).forEach((m) => {
      whs[m].forEach((h) => {
        let startTime = `PT${moment(h.start).format("HH")}H${moment(
          h.start
        ).format("mm")}M`;
        let finishTime = `PT${moment(h.end).format("HH")}H${moment(
          h.end
        ).format("mm")}M`;
        workingHoursSave.push({
          weekday: m.toUpperCase(),
          startTime: startTime,
          finishTime: finishTime,
        });
      });
    });
    if (workingHoursSave.length > 0) {
      runUpdateWorkingHoursCoach({
        variables: {
          input: {
            coachId: location.state.coachId,
            workingHours: workingHoursSave,
          },
        },
      })
        .then((response) => {
          setWorkingHours(whs);
          setWhsModified(true);
          setShowLoader(false);
          setOpenModal(true);
        })
        .catch((error) => {
          const errorMessage = error.message.split("\n")[0];
          NotificationManager.error(errorMessage, "", 5000);
          setShowLoader(false);
          setOpenModal(false);
          setWhsModified(true);
        });
    } else {
      setShowLoader(false);
    }
  };

  const copyFn = (day) => {
    if (hoursCopied.length) {
      let position = hoursCopied.findIndex((i) => i === day);
      if (position > -1) {
        hoursCopied.splice(position, 1);
      } else {
        hoursCopied.push(day);
      }
    } else {
      hoursCopied.push(day);
    }
  };

  const CopyWorkingHours = () => {
    if (action === "add") {
      let whs = Object.assign({}, workingHours);
      hoursCopied.forEach((m) => {
        let copydto = Object.assign([], whs[showHoursCopy]);
        whs[m] = copydto;
      });
      setShowHoursCopy("");
      setHoursCopied([]);
      setWorkingHours(whs);
      setWhsModified(true);
    }
    if (action === "edit") {
      let whs = Object.assign({}, workingHours);
      hoursCopied.forEach((m) => {
        let copydto = Object.assign([], whs[showHoursCopy]);
        whs[m] = copydto;
      });
      let workingHoursSave = [];
      Object.getOwnPropertyNames(whs).forEach((m) => {
        whs[m].forEach((h) => {
          let startTime = `PT${moment(h.start).format("HH")}H${moment(
            h.start
          ).format("mm")}M`;
          let finishTime = `PT${moment(h.end).format("HH")}H${moment(
            h.end
          ).format("mm")}M`;
          workingHoursSave.push({
            weekday: m.toUpperCase(),
            startTime: startTime,
            finishTime: finishTime,
          });
        });
      });
      if (workingHoursSave.length > 0) {
        runUpdateWorkingHoursCoach({
          variables: {
            input: {
              coachId: location.state.coachId,
              workingHours: workingHoursSave,
            },
          },
        })
          .then((response) => {
            setShowHoursCopy("");
            setHoursCopied([]);
            setWorkingHours(whs);
            setWhsModified(true);
            setShowLoader(false);
            setOpenModal(true);
          })
          .catch((error) => {
            const errorMessage = error.message.split("\n")[0];
            NotificationManager.error(errorMessage, "", 5000);
            setShowLoader(false);
            setOpenModal(false);
            setShowHoursCopy("");
            setHoursCopied([]);
            whs[rDaysOfWeek.current.state.ariaSelection.value?.value].pop();
            setWorkingHours(whs);
            setWhsModified(true);
          });
      } else {
        NotificationManager.warning(
          "The working hours are mandatory",
          "",
          5000
        );
        setShowLoader(false);
      }
    }
  };

  const handleEndTimeChange = (time) => {
    let newEndTime = new Date(time.value);
    if (startHour && newEndTime && newEndTime < startHour) {
      return;
    } else {
      setEndHour(newEndTime);
    }
  };

  useEffect(() => {
    setUsersCoach(usersForCoach);
  }, [usersForCoach]);

  useEffect(() => {
    if (userSelected) {
      rEmail.current.value = userSelected.userEmail;
      rCountry.current.value = userSelected.location.countryName;
      rCity.current.value = userSelected.location.cityName;
    }
  }, [userSelected]);

  useEffect(() => {
    if (Object.keys(coachEdit).length > 0) {
      rExperience.current.value =
        typeof coachEdit.yearsOfExperience === "number"
          ? coachEdit.yearsOfExperience
          : "";
      rYearsTP.current.value =
        typeof coachEdit.yearsInTp === "number" ? coachEdit.yearsInTp : "";
      rPosition.current.value = coachEdit.position;
      rEmail.current.value = coachEdit.email;
      rCountry.current.value = coachEdit.countryName;
      rCity.current.value = coachEdit.cityName;

      let initialLanguages = coachEdit.wellnessCoachesLanguages.map((l) => {
        return {
          value: `${l.idLanguage}`,
          label: `${l.idLanguageNavigation.language}`,
        };
      });
      rLanguages.current.state.selectValue = initialLanguages;
      rLanguages.current.state.ariaSelection = initialLanguages;

      let initialUserCoach = {
        value: coachEdit.userId,
        label: `${coachEdit.firstName} ${coachEdit.lastName}`,
      };
      rUserCoach.current.state.selectValue = [initialUserCoach];
      rUserCoach.current.state.ariaSelection = initialUserCoach;

      rDescription.current.value = coachEdit.description;
      setRenderAgain((prev) => !prev);
    }
  }, [coachEdit]);

  useEffect(() => {
    if (startHour) {
      const options = [
        {
          value: `${new Date(new Date(startHour).getTime() + 15 * 60000)}`,
          label: `${moment(
            new Date(new Date(startHour).getTime() + 15 * 60000)
          ).format("hh:mm A")}`,
        },
        {
          value: `${new Date(new Date(startHour).getTime() + 30 * 60000)}`,
          label: `${moment(
            new Date(new Date(startHour).getTime() + 30 * 60000)
          ).format("hh:mm A")}`,
        },
        {
          value: `${new Date(new Date(startHour).getTime() + 45 * 60000)}`,
          label: `${moment(
            new Date(new Date(startHour).getTime() + 45 * 60000)
          ).format("hh:mm A")}`,
        },
        {
          value: `${new Date(new Date(startHour).getTime() + 60 * 60000)}`,
          label: `${moment(
            new Date(new Date(startHour).getTime() + 60 * 60000)
          ).format("hh:mm A")}`,
        },
      ];
      const validateOptions = options
        .filter((f) => {
          let momentHour = moment(f.label, "hh:mm A");
          let initialHour = moment(startHour, "hh:mm A");
          let finalHour = moment("00:00", "hh:mm A");
          return momentHour.isAfter(initialHour) || momentHour.isSameOrBefore(finalHour);
        })
        .map((o) => ({ ...o }));
      if (Array.isArray(validateOptions) && validateOptions.length > 0) {
        setOptionsEndTime(validateOptions);
      } else {
        setOptionsEndTime([]);
      }
    }
  }, [startHour]);

  return (
    <ContentCreate>
      <div
        style={{
          color: themeConfig.neutral.iconGray,
          fontWeight: "700",
          fontSize: "18px",
          display: "flex",
        }}
      >
        <PersonIcon style={{ color: themeConfig.neutral.iconGray }} />
        {action === "add" ? "Create" : "Edit"} Coach
      </div>
      <ContentFields>
        <RenderInputsComponent fields={fields}></RenderInputsComponent>
        <FieldFile>
          <label>Coach cover image</label>
          <ContentFile>
            <FileUpload
              accept=".jpg,.png,.jpeg"
              setDataBulkUpload={setDataBulkUpload}
              setFiles={setFiles}
              files={files}
              loadingImage={loadingCoverImage}
            />
          </ContentFile>
        </FieldFile>
      </ContentFields>

      <StyledAccordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <div style={{ color: themeConfig.primary.purple }}>Set Working hours </div>
          <AccordeonLine />
        </AccordionSummary>
        <StyledAccordionDetails>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <ContentSetHours>
              <ContentField>
                <Form.Label style={{ color: themeConfig.primary.icon }}>
                  Days of week
                </Form.Label>{" "}
                <Select
                  styles={customStyles}
                  placeholder="Select a day"
                  ref={rDaysOfWeek}
                  // isMulti={obj.isMulti}
                  // isDisabled={obj.isDisabled}
                  options={[
                    {
                      value: "Monday",
                      label: "Monday",
                    },
                    {
                      value: "Tuesday",
                      label: "Tuesday",
                    },
                    {
                      value: "Wednesday",
                      label: "Wednesday",
                    },
                    {
                      value: "Thursday",
                      label: "Thursday",
                    },
                    {
                      value: "Friday",
                      label: "Friday",
                    },
                    {
                      value: "Saturday",
                      label: "Saturday",
                    },
                    {
                      value: "Sunday",
                      label: "Sunday",
                    },
                  ]}
                // onChange={() => obj.fn()}
                />
              </ContentField>
              <KeyboardTimePicker
                margin="normal"
                id="time-picker"
                // ampm={false}
                variant="inline"
                label="Start time"
                value={startHour}
                onChange={(date) => setStartHour(date)}
                KeyboardButtonProps={{
                  "aria-label": "change time",
                }}
              />
              <ContentField>
                <Form.Label style={{ color: themeConfig.primary.icon }}>End time</Form.Label>{" "}
                <Select
                  styles={customStyles}
                  placeholder="Select the end time"
                  ref={rEndTime}
                  options={optionsEndTime}
                  onChange={(date) => handleEndTimeChange(date)}
                />
              </ContentField>
              {/* <ButtonCreate style={{margin: 'auto'}} onClick={() => {validateWorkingHours()}}>Add</ButtonCreate> */}
              <ButtonAddHours>
                <AddCircleIcon
                  onClick={() => {
                    validateWorkingHours();
                  }}
                />
              </ButtonAddHours>
              <ContentResume>
                {Object.getOwnPropertyNames(workingHours)
                  .filter((f) => workingHours[f].length > 0)
                  .map((m, i) => {
                    return (
                      <CardHours key={i}>
                        <CopyHours>
                          <label style={{ fontWeight: "600" }}>{m}</label>
                          <FileCopyIcon
                            onClick={() => setShowHoursCopy(m)}
                            style={{
                              float: "right",
                              fontSize: "21px",
                              marginRight: "4px",
                              color: themeConfig.neutral.lightGray,
                            }}
                          />
                        </CopyHours>
                        {workingHours[m]
                          .sort((a, b) => a.start - b.start)
                          .map((h, index) => {
                            let start;
                            let end;
                            start = moment(h.start).format("hh:mm a");
                            end = moment(h.end).format("hh:mm a");
                            return (
                              <div
                                key={index}
                                style={{
                                  margin: "1em auto",
                                  borderBottom: "solid #b0acac6e 1px",
                                }}
                              >
                                <InfoHours>
                                  <label style={{ margin: "0" }}>
                                    {start} to {end}
                                  </label>
                                  <DeleteForeverIcon
                                    onClick={() => {
                                      removeHours(m, index);
                                    }}
                                  />
                                </InfoHours>
                              </div>
                            );
                          })}
                      </CardHours>
                    );
                  })}
              </ContentResume>
            </ContentSetHours>
          </MuiPickersUtilsProvider>
        </StyledAccordionDetails>
      </StyledAccordion>
      <div></div>
      <ContentButtons>
        <ButtonCancel
          onClick={() => {
            history.push("/CoachesManagement");
          }}
        >
          Cancel
        </ButtonCancel>
        <ButtonCreate
          onClick={() => {
            validateData();
          }}
        >
          {action === "add" ? "Create" : "Update"} Coach
        </ButtonCreate>
      </ContentButtons>
      {showHoursCopy.length && (
        <PortalModal>
          <ContentCopy>
            <div>
              <CloseIcon
                style={{ float: "right", cursor: "pointer" }}
                onClick={() => setShowHoursCopy("")}
              />
            </div>
            <div style={{ padding: "1em" }}>
              <label>Days of week</label>
              <div>
                {Object.getOwnPropertyNames(workingHours)
                  .filter((f) => f != showHoursCopy)
                  .map((day, index) => {
                    return (
                      <ContainFormCheck key={index}>
                        <FormLabelCheck>
                          <FormForCheck
                            inline
                            type="checkbox"
                            onChange={(e) => {
                              copyFn(day);
                            }}
                          />{" "}
                          <span>{day.substr(0, 1)}</span>
                        </FormLabelCheck>
                      </ContainFormCheck>
                    );
                  })}
              </div>
            </div>
            <ButtonsCopy>
              <ButtonCancel
                onClick={() => {
                  setShowHoursCopy("");
                }}
              >
                Cancel
              </ButtonCancel>
              <ButtonCreate
                onClick={() => {
                  CopyWorkingHours();
                }}
              >
                Accept
              </ButtonCreate>
            </ButtonsCopy>
          </ContentCopy>
        </PortalModal>
      )}
    </ContentCreate>
  );
};
export default CreateCoachComponent;

CreateCoachComponent.propTypes = {
  languages: PropTypes.array,
  usersForCoach: PropTypes.array,
  workingHours: PropTypes.object,
  userSelected: PropTypes.array,
  coachEdit: PropTypes.object,
  files: PropTypes.array,
  setFiles: PropTypes.func,
  setWhsModified: PropTypes.func,
  setWorkingHours: PropTypes.func,
  createNew: PropTypes.func,
  updateOld: PropTypes.func,
  action: PropTypes.string,
  handleCallSpecificUser: PropTypes.func,
  loadingCoverImage: PropTypes.bool,
}
